export const ParagraphStyles = {
  paragraph: 'text-gray text-16px mb-5 font-bold',
}
